<template>
  <div class="ivu-input-wrapper">
    <i
      v-if="clearable && currentValue && !disabled"
      class="ivu-icon ivu-icon-ios-close-circle ivu-input-icon ivu-input-icon-clear ivu-input-icon-normal"
      @click="handleClear"
    ></i>
    <input
      class="ivu-input"
      :value="currentValue|passFormat(isFocus)"
      :placeholder="placeholder"
      :disabled="disabled"
      type="text"
      @input="handleInput"
      @focus="handleFocus"
      @blur="handleBlur"
    ></input>
  </div>
</template>

<script>
export default {
  name: 'Password',
  filters: {
    passFormat(value, isFocus) {
      if (value && !isFocus) {
        let pass = '';
        const { length } = value;
        let len = 1;
        if (length > 6) {
          len = 3;
          pass = value.substr(0, len) + '*'.repeat(length - 2 * len) + value.substr(length - len, len);
        } else if (length > 4) {
          len = 2;
          pass = value.substr(0, len) + '*'.repeat(length - 2 * len) + value.substr(length - len, len);
        } else if (length > 2) {
          len = 1;
          pass = value.substr(0, len) + '*'.repeat(length - 2 * len) + value.substr(length - len, len);
        } else if (length > 1) {
          len = 1;
          pass = `${value.substr(0, len) }*`;
        } else {
          pass = value;
        }
        return pass;
      } else {
        return value;
      }
    },
  },
  props: {
    value: {
      type: String,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    },
  },
  data() {
    return {
      currentValue: this.value,
      isFocus: false,
    };
  },
  watch: {
    value: {
      handler() {
        this.currentValue = this.value;
      },
    },
  },
  methods: {
    handleClear() {
      this.currentValue = '';
      this.$emit('input', '');
    },
    handleInput(e) {
      this.currentValue = e.target.value;
      this.$emit('input', this.currentValue);
    },
    handleFocus() {
      this.isFocus = true;
    },
    handleBlur() {
      this.isFocus = false;
      // 触发表单验证
      this.dispatch('FormItem', 'on-form-blur', this.currentValue);
    },

  },

};
</script>

<style scoped lang="less">

</style>
